import {
  CandidateAiDataBuilder,
  OverrideAiScoresBySlugInput,
} from '../candidate-ai.types';

export const overrideAiScoresBySlug = (builder: CandidateAiDataBuilder) =>
  builder.mutation<any, OverrideAiScoresBySlugInput>({
    query: ({ candidateId, ...payload }) => ({
      url: `/candidate-scores/${candidateId}`,
      method: 'POST',
      body: { ...payload, IsOverride: true },
    }),
    invalidatesTags: (resp, meta, arg) => [
      { type: 'aiScore', id: arg.candidateId },
    ],
  });
